import React from "react";

import internalServerError from "assets/images/internalServerError.svg";

import styles from "./InternalServerError.module.scss";

const InternalServerError = () => {
  return (
    <div className={styles.internalServerErrorContainer}>
      <div className={styles.content}>
        <img
          className={styles.illustration}
          src={internalServerError}
          alt=""
        />
        <h1 className={styles.title}>Internal Server Error</h1>
        <p className={styles.bodyText}>
          Something went wrong on our end. Please try again in a few moments.
        </p>
        <p className={styles.supportText}>
          You may reach out to our customer support team at{" "}
          <span className={styles.supportNumber}>1800-570-6262</span> for
          further assistance.
        </p>
      </div>
    </div>
  );
};

export default InternalServerError;
